import { render, staticRenderFns } from "./Screen2.vue?vue&type=template&id=dffc9940&"
import script from "./Screen2.vue?vue&type=script&lang=js&"
export * from "./Screen2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports